export default __webpack_public_path__ + "static/CharterITCW05-Bold-bdc268a3aa8cc03de428ad5d905ae844.woff";